export enum FeatureName {
  OnBoarding = 'OnBoarding',
  FutureIncomes = 'FutureIncomes',
  MinInstallmentValue = 'MinInstallmentValue',
  OnBoardingConfigurationModal = 'OnBoardingConfigurationModal',
  TransactionDetailsRefundReceiptLink = 'TransactionDetailsRefundReceiptLink',
  RefundReceiptDownload = 'RefundReceiptDownload',
  MinOrderAmount = 'MinOrderAmount',
  WalletPaymentMethod = 'WalletPaymentMethod',
  ChargebackUpload = 'ChargebackUpload',
  StatementCsvExportFuture = 'StatementCsvExportFuture',
  StatementCsvExportAvailable = 'StatementCsvExportAvailable',
  StatementPainel = 'StatementPainel',
  PartialWithdraw = 'PartialWithdraw',
}

export type GetFeatureDiscoveryResponse = {
  featureName: FeatureName;
  discovered: boolean;
};
